import { render, staticRenderFns } from "./BuyingCostsItem.vue?vue&type=template&id=3f36d386&"
import script from "./BuyingCostsItem.vue?vue&type=script&lang=js&"
export * from "./BuyingCostsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports